import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DonChuyCuidamosALosQueMasQuieres from "./sections/DonChuyCuidamosALosQueMasQuieres";
import OurExpertRepairServices from "./sections/OurExpertRepairServices";
import ProductDetailsSpecifications from "./sections/ProductDetailsSpecifications";
import HartleysProStaffPicks from "./sections/HartleysProStaffPicks";
import MetroRideInNumbers from "./sections/MetroRideInNumbers";
import VisitOurPatisserie from "./sections/VisitOurPatisserie";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DonChuyCuidamosALosQueMasQuieres />
      <OurExpertRepairServices />
      <ProductDetailsSpecifications />
      <HartleysProStaffPicks />
      <MetroRideInNumbers />
      <VisitOurPatisserie />
      <Footer />
    </div>;
}